import { axios } from 'utils/axios';

export const marketingOptIn = (params: {
  email?: string;
  source: 'Footer' | 'Foodaid' | 'PuppyClub' | 'Referral' | string;
  petType?: 'dog' | 'cat';
  opt_in_url: string;
  referralEmails?: string;
  referralToken?: string;
  phone?: string;
}): Promise<void> =>
  axios.get(`${process.env.API_ORIGIN_DEFAULT}/marketingOptIn`, { params });

export const marketingDoubleOptIn = (params: {
  email: string;
}): Promise<void> =>
  axios.get(`${process.env.API_ORIGIN_DEFAULT}/marketingDoubleOptIn`, {
    params,
  });
